import React, { useState, useEffect } from "react";
import { fetchIssues, addIssue, deleteIssue } from "./api";
import checkAuth from "./AuthCheck";
import { useNavigate } from 'react-router-dom';

const AdminIssues = () => {
  const navigate = useNavigate();
  const isLoggedIn = checkAuth();

  useEffect(() => {
    if (!isLoggedIn) {
      navigate('/login'); 
    }
  }, [isLoggedIn, navigate]);

  const [showModal, setShowModal] = useState(false);
  const [issues, setIssues] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");
  const [form, setForm] = useState({
    title: "",
    image: null,
    description: "",
  });

  useEffect(() => {
    loadIssues();
  }, []);

  const loadIssues = async () => {
    setLoading(true);
    setError("");
    try {
      const data = await fetchIssues();
      setIssues(data);
    } catch (e) {
      setError("Failed to load issues");
    }
    setLoading(false);
  };

  const toggleModal = () => setShowModal(!showModal);

  const handleChange = (e) => {
    const { name, value, files } = e.target;
    if (name === "image") {
      setForm({ ...form, image: files[0] });
    } else {
      setForm({ ...form, [name]: value });
    }
  };

  const handleAdd = async (e) => {
    e.preventDefault();
    const formData = new FormData();
    formData.append("title", form.title);
    if (form.image) formData.append("image", form.image);
    formData.append("description", form.description);
    try {
      await addIssue(formData);
      setForm({ title: "", image: null, description: "" });
      setShowModal(false);
      loadIssues();
    } catch (e) {
      setError("Failed to add issue");
    }
  };

  const handleDelete = async (id) => {
    if (!window.confirm("Delete this issue?")) return;
    try {
      await deleteIssue(id);
      loadIssues();
    } catch (e) {
      setError("Failed to delete issue");
    }
  };

  return (
    <>
      <div className="horizontal gap-10 align-center" style={{ marginBottom: "20px" }}>
        <h1>Issues</h1>
        <button className="btn-primary-primary" onClick={toggleModal}>
          Add Issue
        </button>
      </div>
      {showModal && (
        <div className="modal">
          <form onSubmit={handleAdd}>
            <input
              type="text"
              name="title"
              value={form.title}
              onChange={handleChange}
              placeholder="Title"
              required
            />
            <input
              type="file"
              name="image"
              accept="image/*"
              onChange={handleChange}
            />
            <textarea
              name="description"
              value={form.description}
              onChange={handleChange}
              placeholder="Description"
              required
            />
            <button type="submit">Add</button>
            <button type="button" onClick={toggleModal}>Cancel</button>
          </form>
        </div>
      )}
      {loading ? (
        <div>Loading...</div>
      ) : error ? (
        <div style={{ color: 'red' }}>{error}</div>
      ) : (
        <div>
          {issues.map(issue => (
            <div key={issue.id} className="event-card blog-cards">
              {issue.image && <img src={issue.image} alt={issue.title} style={{ maxWidth: 120 }} />}
              <div><b>{issue.title}</b></div>
              <div>{issue.description}</div>
              <button onClick={() => handleDelete(issue.id)}>Delete</button>
            </div>
          ))}
        </div>
      )}
    </>
  );
};

export default AdminIssues;
